export var productionDomains = [
    ".nexmo.com",
    ".vonage.com",
    ".telekom.com",
    ".telekom.net"
];
export var developmentDomains = [
    ".nexmo.io",
    ".vonagenetworks.net"
];

//# sourceMappingURL=domains.js.map